var waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout (timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();


// uppl������������sningssettings

function setScreenClass(){
    var fmt = $(window).width();
    var cls =
        (fmt>0&&fmt<=640)?'phone-screen':
            (fmt>640&&fmt<=1280)?'small-screen':
                'screen';

    $('count').innerHTML=fmt+'px -> '+cls;
    document.body.className=cls;
};

// BUG! Se nedan

$(window).scroll(function(){
    $(".screen #menu").css("top",Math.max(0,90-$(this).scrollTop()));
});

//$(window).scroll(function(){
//    $(".small-screen #menu").css("top",Math.max(0,0-$(this).scrollTop()));
//});

// Kolla n������������rmare p������������ hur man kan anspassa vilka scripts som k������������rs vs uppl������������sning

/*******

 ***	Anchor Slider by Cedric Dugas   ***
 *** Http://www.position-absolute.com ***

 Never have an anchor jumping your content, slide it.

 Don't forget to put an id to your anchor !
 You can use and modify this script for any project you want, but please leave this comment as credit.

 *****/



$(document).ready(function() {
    $("a.anchorLink").anchorAnimate()
});

jQuery.fn.anchorAnimate = function(settings) {

    settings = jQuery.extend({
        speed : 500
    }, settings);

    return this.each(function(){
        var caller = this
        $(caller).click(function (event) {
            event.preventDefault()
            var locationHref = window.location.href
            var elementClick = $(caller).attr("href")

            var destination = $(elementClick).offset().top;
            $("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination}, settings.speed, function() {
                window.location.hash = elementClick
            });
            return false;
        })
    })
}

$(window).load(function() {

    //only run this on the ".article"
    if($('.wrapper').length > 0){

        //get content container positions
        start = ($('#start').offset().top);
        video = ($('#video').offset().top);
        artister = ($('#artister').offset().top);
        brollopslatar = ($('#brollopslatar').offset().top);
        referenser = ($('#referenser').offset().top);
        historia = ($('#historia').offset().top);
        kontakt = ($('#kontakt').offset().top);

        //main menu fixed position on scroll
        $(window).scroll(function () {
            moveMenu();
        });

        //put menu in the right place
        moveMenu();

    }
});

function moveMenu(){
    var scroll_top = $(document).scrollTop();
    if(scroll_top >= 200){
    	$('.awesomenavwrapper').css('position', 'fixed');
    	$('.awesomenavwrapper').css('top', '-1px');
    	$('#lead').css('margin-bottom', '92px');
    } else {
        $('.awesomenavwrapper').css('position', 'absolute');
        $('.awesomenavwrapper').css('top', '200px');
        $('#lead').css('', '');
    }

    if(scroll_top < 1200){
        resetMenu();
    }

    scroll_top = scroll_top+1;
    if(scroll_top > start){resetMenu();$('#main_menu ul li:nth-child(1) a').addClass('selected');}
    if(scroll_top > video){resetMenu();$('#main_menu ul li:nth-child(2) a').addClass('selected');}
    if(scroll_top > artister){resetMenu();$('#main_menu ul li:nth-child(3) a').addClass('selected');}
    if(scroll_top > brollopslatar){resetMenu();$('#main_menu ul li:nth-child(4) a').addClass('selected');}
    if(scroll_top > referenser){resetMenu();$('#main_menu ul li:nth-child(5) a').addClass('selected');}
    if(scroll_top > historia){resetMenu();$('#main_menu ul li:nth-child(6) a').addClass('selected');}
    if(scroll_top > kontakt){resetMenu();$('#main_menu ul li:nth-child(7) a').addClass('selected');}
}

function resetMenu(){
    $('#main_menu a').removeClass('selected');
}